import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import './Header.css';

const CALENDLY_URL = 'https://calendly.com/aventalentadvisory/o-1-visa-consultation';

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Who We Work With', href: '#who-we-work-with' },
    { name: 'Our Approach', href: '#our-approach' },
    { name: 'Consultation', href: '#consultation' },
  ];

  return (
    <header className={`header-bravi ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <a href="/" className="logo-bravi">
          <img src="/logo.png" alt="Aven Talent Advisory" className="logo-img" />
          <span>
            Aven <span className="logo-suffix">Talent Advisory</span>
          </span>
        </a>

        <nav className="nav-links-desktop">
          {navLinks.map((link) => (
            <a key={link.name} href={link.href} className="nav-item">
              {link.name}
            </a>
          ))}
        </nav>

        <div className="nav-actions">
          <a href="mailto:info@aventalentadvisory.com" className="btn-text">
            Contact
          </a>
          <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="btn-dark">
            Schedule Consultation
          </a>
        </div>

        <button
          className="mobile-toggle-bravi"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="mobile-menu-bravi"
          >
            {navLinks.map((link) => (
              <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)}>
                {link.name}
              </a>
            ))}
            <div className="mobile-actions">
              <a href="mailto:info@aventalentadvisory.com" className="btn-text">
                Contact
              </a>
              <a
                href={CALENDLY_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-dark w-full"
              >
                Schedule Consultation
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}

export default Header;
